<template>
    <picture :class="classes">
        <source v-if="media.webp"
                type="image/webp"
                :srcset="media.webp"
                sizes="1px"/>
        <source :srcset="media.srcSet"
                sizes="1px" />

        <img
            loading="lazy"
            :src="media.src"
            :width="media.width"
            :height="media.height"
            :alt="alt"
            onload="this.onload=null;this.previousElementSibling.sizes=Math.ceil(this.getBoundingClientRect().width/window.innerWidth*100)+'vw';if(this.previousElementSibling.previousElementSibling){this.previousElementSibling.previousElementSibling.sizes=Math.ceil(this.getBoundingClientRect().width/window.innerWidth*100)+'vw';};this.sizes=Math.ceil(this.getBoundingClientRect().width/window.innerWidth*100)+'vw';"
            sizes="1px"
        >
    </picture>
</template>

<script>
export default {
    name: 'ResponsiveImage',

    props: {
        media: {
            type: Object
        },
        alt: {
            type: String,
            default: ''
        },
        classes: {
            type: String,
            default: 'product-image'
        }
    }
}
</script>
